import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Person } from "@/Common/Models/Person/Person";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IGroupDetailsSettingViewComponentProps {
    model: IGroupTabModel;
}

class GroupDetailsSettingViewComponentState {
    public selectedGroup: EmployeeGroupUIModel;
    public clinicians: Person[];
    public selectClinician: Person;
    public tempListClinician: Person[];
    public isReloadGroup: boolean;
}

class GroupDetailsSettingViewComponent extends BaseReactComponent<IGroupDetailsSettingViewComponentProps, GroupDetailsSettingViewComponentState> {
    public constructor(props: Readonly<IGroupDetailsSettingViewComponentProps>) {
        super(props);
        const selectedGroup = props.model.get("SelectedGroup");
        this.state = {
            selectedGroup: selectedGroup,
            tempListClinician: selectedGroup.getAllClinicianByContactFacetId(),
            clinicians: cacheStore.GetClinicians(true),
            selectClinician: null,
            isReloadGroup: null
        };
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(prevProps: IGroupDetailsSettingViewComponentProps): void {
        let currentGroup = this.props.model.get("SelectedGroup");
        let prevGroup = prevProps.model.get("SelectedGroup");
        if (currentGroup != prevGroup) {
            this.mutateState(s => {
                s.selectedGroup = currentGroup;
                s.tempListClinician = s.selectedGroup.getAllClinicianByContactFacetId();
                s.clinicians = this.state.clinicians;
            });
        }
    }

    public render(): JSX.Element {
        return (
            <div>
                <div style={{ margin: "10px", marginTop: "20px" }}>
                    <h3 className="thin-font"> {this.state.selectedGroup.Model.Name}  <a style={{ fontSize: "14px" }} onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.IsRenameGroupPopupOpen)}>{cacheStore.GetString("EDITLabel")}</a></h3>
                </div>

                <div className="user-component">
                    <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                        <div className="h">
                            <h3 className="thin-font">{cacheStore.GetString("MemberLabel")}</h3>
                        </div>
                    </div>
                    <div className="psingle-column practice centered">
                        <div className="tb">
                            {this.renderMemberInfo()}
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    private renderMemberInfo(): JSX.Element {
        let group = this.state.selectedGroup;
        let users: Person[] = [];
        let usersName = null;

        if (group.Model.EmployeeContactFacetIds != null && group.Model.EmployeeContactFacetIds.length > 0) {
            users = cacheStore.GetClinicians(true).filter(c => {
                let i = group.Model.EmployeeContactFacetIds.filter(z => z === c.ContactFacetId).length;
                return i > 0;
            });

            usersName = users.map((x, idx) => (
                <div key={"memeber_" + idx}>{x.NameWithPrefix}</div>
            ));
        }

        return (
            <div className="tbc">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><label className="form-label">{cacheStore.GetString("MemberLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "verticalAlign": "top" }}><strong>{MyleHelper.ReplaceEmptyString(usersName)}</strong></td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export { GroupDetailsSettingViewComponent };
